import type { MappingState, ColumnName } from '../../../../common/types';

export const getValidationError = (mappingState: MappingState | null, columnName: ColumnName) =>
	mappingState?.validationError?.columnErrors?.[columnName] || null;
